/**
 * Created by hernanherreros on 2019-07-21
 */

import Activities from './containers/Activities'

export default Activities